import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedClockPlus = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 50 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g filter="url(#filter0_i_2274_47946)">
          <circle cx="23.75" cy="23.5" r="19" fill="url(#paint0_linear_2274_47946)" />
        </g>
        <path
          d="M39.8733 19.9715C40.2734 19.8643 40.5109 19.453 40.4037 19.0529C40.2965 18.6528 39.8852 18.4154 39.4851 18.5226L24.5133 22.5343C24.1132 22.6415 23.8757 23.0527 23.9829 23.4528C24.0901 23.8529 24.5014 24.0904 24.9015 23.9832L39.8733 19.9715Z"
          fill="white"
        />
        <path
          d="M22.75 9.5C22.75 8.94772 23.1977 8.5 23.75 8.5C24.3023 8.5 24.75 8.94772 24.75 9.5V24C24.75 24.5523 24.3023 25 23.75 25C23.1977 25 22.75 24.5523 22.75 24V9.5Z"
          fill="white"
        />
        <g filter="url(#filter1_d_2274_47946)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.3109 20.8063C25.4804 20.5883 25.7945 20.5491 26.0125 20.7186C26.2305 20.8881 26.2697 21.2023 26.1002 21.4203L25.4012 22.319C25.6079 22.5904 25.7479 22.9185 25.7932 23.2814C25.9303 24.3775 25.1528 25.377 24.0568 25.514C23.6941 25.5594 23.342 25.5046 23.0283 25.3713L13.4313 37.7102C13.2618 37.9282 12.9476 37.9675 12.7296 37.7979C12.5117 37.6284 12.4724 37.3143 12.6419 37.0963L22.2343 24.7633C22.0176 24.4874 21.8708 24.151 21.8241 23.7776C21.6871 22.6815 22.4646 21.6819 23.5606 21.5449C23.9337 21.4983 24.2957 21.5576 24.6162 21.6994L25.3109 20.8063Z"
            fill="#FFD900"
          />
        </g>
        <path
          d="M23.25 6C23.25 5.72386 23.4739 5.5 23.75 5.5C24.0261 5.5 24.25 5.72386 24.25 6V7C24.25 7.27614 24.0261 7.5 23.75 7.5C23.4739 7.5 23.25 7.27614 23.25 7V6Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M35.7708 10.772C35.9661 10.5767 36.2827 10.5767 36.4779 10.772C36.6732 10.9673 36.6732 11.2839 36.4779 11.4791L35.7708 12.1862C35.5756 12.3815 35.259 12.3815 35.0637 12.1862C34.8685 11.991 34.8685 11.6744 35.0637 11.4791L35.7708 10.772Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M6.25 24C5.97386 24 5.75 23.7761 5.75 23.5C5.75 23.2239 5.97386 23 6.25 23L7.25 23C7.52614 23 7.75 23.2239 7.75 23.5C7.75 23.7761 7.52614 24 7.25 24L6.25 24Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M11.0221 11.4793C10.8268 11.284 10.8268 10.9674 11.0221 10.7722C11.2173 10.5769 11.5339 10.5769 11.7292 10.7722L12.4363 11.4793C12.6315 11.6745 12.6315 11.9911 12.4363 12.1864C12.241 12.3817 11.9244 12.3817 11.7292 12.1864L11.0221 11.4793Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M23.25 40C23.25 39.7239 23.4739 39.5 23.75 39.5C24.0261 39.5 24.25 39.7239 24.25 40V41C24.25 41.2761 24.0261 41.5 23.75 41.5C23.4739 41.5 23.25 41.2761 23.25 41V40Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M11.7292 34.8138C11.9245 34.6185 12.2411 34.6185 12.4363 34.8138C12.6316 35.009 12.6316 35.3256 12.4363 35.5209L11.7292 36.228C11.5339 36.4232 11.2174 36.4232 11.0221 36.228C10.8268 36.0327 10.8268 35.7161 11.0221 35.5209L11.7292 34.8138Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M40.25 24C39.9739 24 39.75 23.7761 39.75 23.5C39.75 23.2239 39.9739 23 40.25 23L41.25 23C41.5261 23 41.75 23.2239 41.75 23.5C41.75 23.7761 41.5261 24 41.25 24L40.25 24Z"
          fill="white"
          fillOpacity="0.4"
        />
        <g filter="url(#filter2_d_2274_47946)">
          <rect x="26.6499" y="26.5" width="20" height="20" rx="10" fill="url(#paint1_linear_2274_47946)" />
          <g filter="url(#filter3_d_2274_47946)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.7863 30.8552C36.1726 30.8552 35.6752 31.3527 35.6752 31.9663V35.2186H32.1392C31.5256 35.2186 31.0281 35.7161 31.0281 36.3297C31.0281 36.9434 31.5256 37.4408 32.1392 37.4408H35.6752V41.0337C35.6752 41.6474 36.1726 42.1448 36.7863 42.1448C37.3999 42.1448 37.8974 41.6474 37.8974 41.0337V37.4408H41.2066C41.8203 37.4408 42.3177 36.9434 42.3177 36.3297C42.3177 35.7161 41.8203 35.2186 41.2066 35.2186H37.8974V31.9663C37.8974 31.3527 37.3999 30.8552 36.7863 30.8552Z"
              fill="white"
              fillOpacity="0.8"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_i_2274_47946"
            x="4.75"
            y="4.5"
            width="38"
            height="38"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2274_47946" />
          </filter>
          <filter
            id="filter1_d_2274_47946"
            x="10.5366"
            y="19.6133"
            width="17.6689"
            height="21.29"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2274_47946" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2274_47946" result="shape" />
          </filter>
          <filter
            id="filter2_d_2274_47946"
            x="23.6499"
            y="25.5"
            width="26"
            height="26"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2274_47946" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2274_47946" result="shape" />
          </filter>
          <filter
            id="filter3_d_2274_47946"
            x="29.0281"
            y="29.8552"
            width="15.2896"
            height="15.2896"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2274_47946" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2274_47946" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_2274_47946"
            x1="23.75"
            y1="4.5"
            x2="23.75"
            y2="42.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B200CD" stopOpacity="0.7" />
            <stop offset="1" stopColor="#2B00B6" stopOpacity="0.8" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2274_47946"
            x1="36.6499"
            y1="26.5"
            x2="36.6499"
            y2="46.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#18D6B3" />
            <stop offset="1" stopColor="#039400" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedClockPlus
